/**
 *  Minicart product recommendations slider.
 *  Swiper is used on mobile only; desktop keeps the native vertical layout.
 */
(function () {
  var DESKTOP_BREAKPOINT = 1068;
  var swiper = null;

  function getContainer() {
    return document.querySelector('.cart-drawer--recommendations--products');
  }

  function isMobile() {
    return window.innerWidth < DESKTOP_BREAKPOINT;
  }

  function destroy() {
    if (swiper) {
      try {
        swiper.destroy(true, true);
      } catch (e) {}
      swiper = null;
    }
    var container = getContainer();
    if (container) {
      container.classList.remove('swiper-container');
    }
  }

  function init() {
    if (typeof Swiper === 'undefined') {
      return;
    }

    var container = getContainer();

    if (!container || !container.querySelectorAll('.swiper-slide').length || !isMobile()) {
      destroy();
      return;
    }

    if (swiper) {
      return;
    }

    container.classList.add('swiper-container');
    swiper = new Swiper(container, {
      slidesPerView: 1.15,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: container.querySelector('.cart-rec-swiper-pagination'),
        clickable: true
      }
    });
  }

  document.addEventListener('cart-recommendations:loaded', function () {
    destroy();
    init();
  });

  window.addEventListener('resize', debounce(init, 200));
})();
